import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { FieldType, GetState } from 'src/hooks/useForm';

export const SIGN_UP_DATA_STORAGE_KEY = 'sign-up-data';

type FieldsTypes = {
  email: FieldType.Text;
  password: FieldType.Text;
  country: FieldType.Autocomplete;
  is18years: FieldType.Checkbox;
  news: FieldType.Checkbox;
};

type FieldKeys = keyof FieldsTypes;

interface StorageProps {
  triggerForSaveData: string | undefined;
  values: GetState<FieldsTypes>;
  setValues: Dispatch<SetStateAction<GetState<FieldsTypes>>>;
  storedValues: FieldKeys[];
}

export const useCacheSignUpData = ({
  triggerForSaveData,
  values,
  setValues,
  storedValues
}: StorageProps) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    const data = sessionStorage.getItem(SIGN_UP_DATA_STORAGE_KEY);
    if (!data) return;

    try {
      const valuesFromStore = JSON.parse(data);
      if (valuesFromStore && typeof valuesFromStore === 'object') {
        setValues({ ...values, ...valuesFromStore });
      }
    } catch (_) {
      console.error(`Invalid JSON in sessionStorage: ${SIGN_UP_DATA_STORAGE_KEY}`);
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const neededValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key]) => storedValues.includes(key as FieldKeys) && Boolean(values[key as FieldKeys])
      )
    );
    sessionStorage.setItem(SIGN_UP_DATA_STORAGE_KEY, JSON.stringify(neededValues));
  }, [triggerForSaveData]);
};
